module.exports = __webpack_public_path__ + "fonts/iconfont.34cf71e.ttf";